import { useState } from 'react';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { message } from 'antd';

import userApi from '@api/userApi';
import { useTranslation } from 'react-i18next';

function useResetPassword() {

  const { t } = useTranslation();

  const history = useHistory();
  const { params } = useRouteMatch();
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const { token } = params;

  const onUserResetPassword = (values) => {

    if (values.new_password !== values.repeat_new_password) {

      message.error(t('forms.recovery_password.feedbacks.different_passwords'));
      return false;

}
    setLoading(true);
    const body = {
      token,
      new_password: values.new_password,
    };

    setLoading(true);
    userApi
      .resetPasswordConfirm(body)
      .then(() => {

        message.success(t('forms.recovery_password.feedbacks.success_recovery_passwords'));
        setLoading(false);
        history.push('/');

})
      .catch(() => {

        setLoading(false);
        message.error(t('forms.recovery_password.feedbacks.failed_recovery_passwords'));

      });

      return false;

};

  return {
    onUserResetPassword, password, setPassword, loading,
  };

}

export default useResetPassword;
